import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../theme/getTheme'

/** Horizontal padding of the friends tab content (ScrollView). Used so the grid uses content width and stays centered. */
export const FRIENDS_CONTENT_PADDING_HORIZONTAL = 16

export const getFriendsPageStyles = (theme: Theme) => StyleSheet.create({
  belowHeaderContent: {
    flex: 1,
  },
  container: {
    flex: 1,
    paddingTop: 0,
    backgroundColor: theme.background.primary, // Light purple background like sign-in page
    ...(Platform.OS === 'web' && {
      height: '100vh' as never,
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden' as never,
      overflowX: 'hidden' as never,
      boxSizing: 'border-box' as never,
    }),
  },
  toggleContainer: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 6,
    minHeight: 48,
  },
  filterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingBottom: 8,
  },
  content: {
    flex: 1,
    paddingHorizontal: FRIENDS_CONTENT_PADDING_HORIZONTAL,
    paddingTop: Platform.OS === 'web' ? 4 : 12,
    paddingBottom: 16,
    ...(Platform.OS === 'web' && {
      scrollbarWidth: 'none' as never, // Hide scrollbar on web (Firefox; Chrome may need global ::-webkit-scrollbar)
    }),
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 100,
  },
  loadingText: {
    color: '#FFFFFF', // White text
    fontSize: 16,
    fontWeight: '600',
  },
})

// Backward compatibility - export default styles using light theme
import { getTheme } from '../../theme/getTheme'
export const friendsPageStyles = getFriendsPageStyles(getTheme('light'))
